import React from "react";
import { Loader2 } from "lucide-react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-5 sm:mb-6" data-testid={testid || "page-header"}>
      <div className="min-w-0">
        <h1 className="font-heading text-xl sm:text-3xl font-semibold tracking-tight text-zinc-50 truncate">{title}</h1>
        {subtitle && <p className="text-xs sm:text-sm text-zinc-400 mt-1 leading-relaxed">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Card({ children, className = "", testid }) {
  return (
    <div
      className={`bg-[#0c0c0c] border border-zinc-900 rounded-lg ${className}`}
      data-testid={testid}
    >
      {children}
    </div>
  );
}

export function Empty({ title, subtitle, action, testid }) {
  return (
    <div className="border border-dashed border-zinc-800 rounded-lg py-16 px-8 text-center" data-testid={testid || "empty-state"}>
      <div className="text-zinc-300 font-heading font-medium">{title}</div>
      {subtitle && <div className="text-sm text-zinc-500 mt-1">{subtitle}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Spinner({ label }) {
  return (
    <div className="flex items-center gap-2 text-zinc-500 text-sm">
      <Loader2 className="h-4 w-4 animate-spin" /> {label || "Laster…"}
    </div>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`bg-zinc-900/60 rounded animate-pulse ${className}`} />;
}
